import { Directive, Input, OnInit, TemplateRef, ViewContainerRef } from '@angular/core';

import { AclService } from '../../data/acl.service';
import { ResponsiveCommon } from '../../responsive.common';

@Directive({ selector: '[aclFeatures]' })
export class AclDirective extends ResponsiveCommon implements OnInit {

	@Input() aclFeatures: string | string[];

	@Input() aclFeaturesAnd: boolean = true;

	constructor(private aclService: AclService,
		private templateRef: TemplateRef<any>,
		private viewContainer: ViewContainerRef) {
		super();
	}

	ngOnInit(): void {
		if (this.aclService.hasPermission(this.aclFeatures, this.aclFeaturesAnd)) {
			if (!this.responsive) this.pass();
			else {
				if (Array.isArray(this.aclFeatures)) {
					if (this.aclFeatures.every(feat => feat.includes('section'))) this.handle();
					else this.pass();
				} else {
					if (this.aclFeatures.includes('section')) this.handle();
					else this.pass();
				}
			}
		} else {
			this.reject();
		}
	}

	pass() {
		this.viewContainer.createEmbeddedView(this.templateRef);
	}

	reject() {
		this.viewContainer.clear();
	}

	handle() {
		const allowedFeats = this.allowedSections.some(section => this.aclFeatures.indexOf(section) >= 0);
		if (allowedFeats) this.pass();
		else this.reject();
	}
}
